module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "extend-info publish-main"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "size": "small",
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('title-area', {
    attrs: {
      "title": "应用名称"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应用名称："
    }
  }, [_c('el-input', {
    staticClass: "auto-width",
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.appName),
      callback: function($$v) {
        _vm.$set(_vm.form, "appName", $$v)
      },
      expression: "form.appName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "英文名称：",
      "prop": "appEnName"
    }
  }, [_c('el-input', {
    staticClass: "auto-width",
    attrs: {
      "disabled": _vm.hid,
      "maxlength": "60",
      "placeholder": "最多输入60个字符，只允许英文和数字"
    },
    model: {
      value: (_vm.form.appEnName),
      callback: function($$v) {
        _vm.$set(_vm.form, "appEnName", $$v)
      },
      expression: "form.appEnName"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hints"
  }, [_vm._v("最多输入60个字符，只允许英文和数字")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "桌面显示名称：",
      "prop": "viewName"
    }
  }, [_c('el-input', {
    staticClass: "auto-width",
    attrs: {
      "disabled": _vm.hid,
      "maxlength": "6",
      "placeholder": "显示在桌面的名称"
    },
    model: {
      value: (_vm.form.viewName),
      callback: function($$v) {
        _vm.$set(_vm.form, "viewName", $$v)
      },
      expression: "form.viewName"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hints"
  }, [_vm._v("最多输入6个汉字")])], 1)], 1), _vm._v(" "), _c('title-area', {
    attrs: {
      "title": "版本编号"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "versionNo"
    }
  }, [_c('el-input', {
    staticClass: "auto-width",
    attrs: {
      "disabled": _vm.hidsubv,
      "maxlength": "20",
      "placeholder": "英文和数字以及“.”20字符以内"
    },
    model: {
      value: (_vm.form.versionNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "versionNo", $$v)
      },
      expression: "form.versionNo"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hints"
  }, [_vm._v("与安装包版本号一致")])], 1)], 1), _vm._v(" "), _c('title-area', {
    attrs: {
      "title": "数据服务包"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "增值服务：",
      "prop": "addservicesCheck"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.addservicesCheck),
      callback: function($$v) {
        _vm.$set(_vm.form, "addservicesCheck", $$v)
      },
      expression: "form.addservicesCheck"
    }
  }, _vm._l((_vm.appAddServices), function(item, index) {
    return _c('el-checkbox', {
      key: item.id,
      staticClass: "check-list",
      attrs: {
        "disabled": _vm.hid,
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.dictionaryname))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据接口权限：",
      "prop": "interfaceCheck"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.interfaceCheck),
      callback: function($$v) {
        _vm.$set(_vm.form, "interfaceCheck", $$v)
      },
      expression: "form.interfaceCheck"
    }
  }, _vm._l((_vm.appInterface), function(item, index) {
    return _c('el-checkbox', {
      key: item.id,
      staticClass: "check-list",
      attrs: {
        "disabled": _vm.hid,
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.dictionaryname))])
  }), 1)], 1)], 1), _vm._v(" "), _c('title-area', {
    attrs: {
      "title": _vm.deployType == 109002 ? '部署应用' : '访问地址'
    }
  }, [(_vm.deployType == 109002) ? _c('el-form-item', {
    attrs: {
      "label": "上传安装包",
      "prop": "appInstallpackagePath",
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "upload-wrap",
    attrs: {
      "disabled": _vm.hidsubv
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/zklccloud/upload",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "on-progress": _vm.uploadprogress,
      "data": {
        'access_token': _vm.accessToken
      },
      "disabled": _vm.uploadDisabled
    }
  }, [(_vm.uploadDisabled) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": require("../img/icon-azb.png")
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), (_vm.uploadDisabled) ? _c('div', {
    staticClass: "name text-space"
  }, [_vm._v(_vm._s(_vm.originalFilename))]) : _vm._e()]), _vm._v(" "), (_vm.uploaddel) ? _c('i', {
    staticClass: "el-icon-circle-close cursor",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.delAzb.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-progress', {
    class: {
      'is-visibility': _vm.progress === 0 || _vm.progress === 100
    },
    staticStyle: {
      "width": "198px"
    },
    attrs: {
      "percentage": _vm.progress
    }
  })], 1) : _c('el-form-item', {
    attrs: {
      "label-width": "0",
      "prop": "visitUrl"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "maxlength": "500"
    },
    model: {
      value: (_vm.form.visitUrl),
      callback: function($$v) {
        _vm.$set(_vm.form, "visitUrl", $$v)
      },
      expression: "form.visitUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('title-area', {
    attrs: {
      "title": "应用介绍",
      "margin-left": 56,
      "padding-right": 60,
      "dashed": false
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "appComment",
      "label-width": "0"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入内容",
      "disabled": _vm.hid
    },
    model: {
      value: (_vm.form.appComment),
      callback: function($$v) {
        _vm.$set(_vm.form, "appComment", $$v)
      },
      expression: "form.appComment"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-92cc4ef6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/publish_apply/module/ext_info.vue
// module id = 1277
// module chunks = 1